import GeneralHands from '@/services/hands/GeneralHands';
import shareUrlService from '@/services/share-url-service';
import constants from '@/services/constants';

let state = {
  generalHands: new GeneralHands(),
  indexOfSelectedAction: 0,
  actions: [{
    name: 'Raise',
    color: 'green',
  }, {
    name: 'Call',
    color: 'blue',
  }, {
    name: 'Fold',
    color: 'red',
  }, {
    name: 'Not possible',
    color: 'impossible',
    immutableName: true,
  }],
};

let mutations = {
  setState: function (state, stateFromServer) {
    shareUrlService.setRangeConstructorStoreState(stateFromServer, state);
  },

  // grid
  selectGeneralHand: function (state, generalHandString) {
    let generalHand = state.generalHands.find(generalHandString);

    generalHand.color = state.actions[state.indexOfSelectedAction].color;
    generalHand.forEachSpecificHand(function (specificHand) {
      specificHand.weight = 100;
    });
  },
  deselectGeneralHand: function (state, generalHandString) {
    let generalHand = state.generalHands.find(generalHandString);

    generalHand.color = null;
    generalHand.forEachSpecificHand(function (specificHand) {
      specificHand.weight = 0;
    });
  },
  selectGeneralHands: function (state, generalHandStrings) {
    let generalHand;

    generalHandStrings.forEach(function (generalHandString) {
      generalHand = state.generalHands.find(generalHandString);
      generalHand.color = state.actions[state.indexOfSelectedAction].color;
      generalHand.forEachSpecificHand(function (specificHand) {
        specificHand.weight = 100;
      });
    });
  },
  deselectGeneralHands: function (state, generalHandStrings) {
    let generalHand;

    generalHandStrings.forEach(function (generalHandString) {
      generalHand = state.generalHands.find(generalHandString);
      generalHand.color = null;
      generalHand.forEachSpecificHand(function (specificHand) {
        specificHand.weight = 0;
      });
    });
  },
  deselectAllGeneralHands: function (state) {
    let allGeneralHandStrings = constants.handRankings['sklansky-chubukov'];
    let generalHand;

    allGeneralHandStrings.forEach(function (generalHandString) {
      generalHand = state.generalHands.find(generalHandString);
      generalHand.color = null;
      generalHand.forEachSpecificHand(function (specificHand) {
        specificHand.weight = 0;
      });
    });
  },
  applyToAllUnselectedHands: function (state, color) {
    state.generalHands.forEach(function (generalHand) {
      if (generalHand.color === null) {
        generalHand.color = color;
        generalHand.forEachSpecificHand(function (specificHand) {
          specificHand.weight = 100;
        });
      }
    });
  },

  // actions
  selectAction: function (state, index) {
    state.indexOfSelectedAction = index;
  },
  setNameOfAction: function (state, payload) {
    state.actions[payload.index].name = payload.name;
  },
  addAction: function (state) {
    let newColor;
    let greenUsed = state.actions.find(function (action) {
      return action.color === 'green';
    });
    let blueUsed = state.actions.find(function (action) {
      return action.color === 'blue';
    });
    let redUsed = state.actions.find(function (action) {
      return action.color === 'red';
    });
    let yellowUsed = state.actions.find(function (action) {
      return action.color === 'yellow';
    });
    let orangeUsed = state.actions.find(function (action) {
      return action.color === 'orange';
    });
    let purpleUsed = state.actions.find(function (action) {
      return action.color === 'purple';
    });
    let brownUsed = state.actions.find(function (action) {
      return action.color === 'brown';
    });

    if (!greenUsed) {
      newColor = 'green';
    } else if (!blueUsed) {
      newColor = 'blue';
    } else if (!redUsed) {
      newColor = 'red';
    } else if (!yellowUsed) {
      newColor = 'yellow';
    } else if (!orangeUsed) {
      newColor = 'orange';
    } else if (!purpleUsed) {
      newColor = 'purple';
    } else if (!brownUsed) {
      newColor = 'brown';
    }

    state.actions.splice(state.actions.length - 1, 0, {
      name: `Action #${state.actions.length}`,
      color: newColor,
    });
  },
  removeAction: function (state, index) {
    state.actions.splice(index, 1);
  },
};

let getters = {
  percentageForAction: function (state, getters) {
    return function (actionColor) {
      let numCombosForAction = 0;

      state.generalHands.forEach(function (generalHand) {
        if (generalHand.color === actionColor) {
          numCombosForAction += generalHand.numSpecificHandsInRange;
        }
      });

      return ((numCombosForAction / getters.numberOfPossibleSpecificHands) * 100).roundToTwoDecimalPlaces();
    };
  },
  numberOfPossibleSpecificHands: function (state) {
    let numberOfPossibleSpecificHands = 0;

    state.generalHands.forEach(function (generalHand) {
      if (generalHand.color !== 'impossible') {
        numberOfPossibleSpecificHands += generalHand.numPossibleSpecificHands;
      }
    });

    return numberOfPossibleSpecificHands;
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
};

export { state, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/range-constructor/range-constructor.js